import React, { Component } from 'react';
import propTypes from 'prop-types';
import { toggleState, updateFieldInState } from 'utils/ComponentUtilFunctions';

import Modal from 'react-modal';
import moment from 'moment';
import Calendar from 'react-calendar';
import CalendarIcon from '../../../../../assets/images/calendar.svg';
import Translate from '../../../../../components/Translate';
import config from "../../../../../config";

const styles = {
  wrapper: {
    width: '100%',
    position: 'relative',
  },
  headerWrapper: {
    height: '50px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  calendar: {
    height: '50px',
    width: '50px',
    float: 'left',
    cursor: 'pointer',
    WebkitBoxShadow: '1px 1px 5px 0px rgba(29,51,100,0.17)',
    MozBoxShadow: '1px 1px 5px 0px rgba(29,51,100,0.17)',
    boxShadow: '1px 1px 5px 0px rgba(29,51,100,0.17)',
    borderRadius: '50%',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: '10px',
    textAlign: 'left',
  },
  title: {
    color: '#7A7A7A',
    fontSize: '14px',
  },
  calendarWrapper: {
    position: 'absolute',
    width: '250px',
    paddingTop: '10px',
  },
  modal: {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      borderRadius: '20px',
      transform: 'translate(-50%, -50%)',
    },
    overlay: {
      backgroundColor: config.modalBackgroundColor,
      zIndex: '2000',
    },
  },
};

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarOpen: false,
    };

    this.toggleState = toggleState.bind(this);
    this.updateFieldInState = updateFieldInState.bind(this);
  }

  handleDateChange = (date) => {
    const { handleDateChange } = this.props;
    handleDateChange(date[0], date[1]);
  };

  render() {
    const { calendarOpen } = this.state;
    const { language, endDate, startDate } = this.props;

    return (
      <div>
        <div style={styles.headerWrapper}>
          <img
            src={CalendarIcon}
            alt="Crete Client"
            style={styles.calendar}
            onClick={this.toggleState('calendarOpen')}
          />
          <div style={styles.titleWrapper}>
            <p style={styles.title}>
              <Translate text="from" />
            </p>
            <p style={styles.title}>
              <Translate text="to" />
            </p>
          </div>
          <div style={styles.titleWrapper}>
            <p style={styles.title}>
              {moment(startDate)
                .format('MM.DD.YY')}
            </p>
            <p style={styles.title}>
              {moment(endDate)
                .format('MM.DD.YY')}
            </p>
          </div>
        </div>
        <Modal
          closeTimeoutMS={config.closeTimeoutMS}
          isOpen={calendarOpen}
          onRequestClose={this.updateFieldInState('calendarOpen', false)}
          style={styles.modal}
        >
          <Calendar
            selectRange
            locale={language}
            value={[startDate, endDate]}
            onChange={this.handleDateChange}
          />
        </Modal>
      </div>
    );
  }
}

DatePicker.propTypes = {
  language: propTypes.string.isRequired,
  endDate: propTypes.object.isRequired,
  startDate: propTypes.object.isRequired,
  handleDateChange: propTypes.func.isRequired,
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/DatePicker.jsx